import { AUTH_ROUTES, wsTicketOutput, } from "@repo/contract/iam";
import { readJson } from "../api/auth-api";
/**
 * Buying one ticket (`D34`, `T42`).
 *
 * ── IT GOES THROUGH `ApiClient.authorizedFetch`, AND THAT IS NOT OPTIONAL ───
 * The refresh token is opaque, single-use and rotating (`D15`), and presenting
 * a spent one is treated as THEFT: the server revokes the whole token family
 * and the user is signed out of every device. `ApiClient` is the one object
 * allowed to spend one, and its defence is a single shared in-flight promise —
 * a field on that instance. A second fetch path here, however small, is a
 * second refresh racing the first, and the symptom is a user signed out at
 * random with nothing in any log to explain it.
 *
 * So this function takes the client's own `authorizedFetch` and does no
 * credential handling of its own. It gets the 401 retry and the proactive
 * refresh for free, which is exactly what a socket that closes on `4401` needs.
 *
 * ── THE LOCALE RIDES THE TICKET, NOT THE TURN (`D43`) ───────────────────────
 * The trainer answers in the user's language, and a WebSocket has exactly one
 * handshake — there is no per-request slot to put a locale in, which is what
 * the catalogue's `?locale=` uses. So it travels here, in the mint, and the
 * envelope carries it inward to the system prompt.
 *
 * It is the APP's stored setting (`D42`) and never the device's current
 * language. Someone who chose English on a Portuguese phone must be answered in
 * English — the same rule the sign-in email follows.
 *
 * ── ONE TICKET PER CONNECTION ATTEMPT. NEVER CACHED, NEVER REUSED ───────────
 * Consumption on the agent Worker deletes the stored ticket UNCONDITIONALLY,
 * before any decision is taken, so unknown, replayed and expired all answer 401
 * indistinguishably. A cached ticket therefore does not fail with a message
 * naming the mistake — it fails as a handshake that will not open, forever,
 * which reads as a broken server. Sixty seconds of life is the other half of
 * the argument for why a credential in a URL is acceptable at all.
 */
export function buyWsTicket(authorizedFetch, locale) {
    const body = { locale };
    return authorizedFetch(AUTH_ROUTES.wsTicket, {
        body: JSON.stringify(body),
        headers: { "content-type": "application/json" },
        method: "POST",
    }).then(
    // PARSED, not cast. A drifted field would otherwise reach `chatSocketUrl`
    // as `undefined`, producing `?ticket=undefined` — a handshake refused with
    // the same 401 as a forged ticket, on a client that looks correct.
    (response) => readJson(response, wsTicketOutput));
}
//# sourceMappingURL=ws-ticket.js.map